// extracted by mini-css-extract-plugin
export default {"appleLoginButton":"AppleSignInButton__appleLoginButton___dp9tj"};